import { Event } from './event.model';

export class EventDetail extends Event {
  public notes: string;
  public eventType: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/model/event-detail.model.ts